import Link from 'next/link'
import { apiBaseAddress } from '../../config'
import ColoredDivider from '../coloredDivider.component'
import Slogan from '../slogan.component'
import Toolbar from './toolbar.component'

const HeaderBlockContent: React.FC<{ slogan: string; subTitle: string }> = ({
  slogan,
  subTitle,
}) => {
  return (
    <div className='h-home-header-assets relative 2xl:h-home-header-2xl text-white text-header-text font-semibold font-montserrat 2xl:text-header-text-2xl'>
      <div className='flex justify-end h-full py-4 2xl:py-8 '>
        <div className='w-full flex flex-col items-end justify-between 2xl:justify-start'>
          <div className='w-1/3 2xl:w-full'>
            <Toolbar />
          </div>
          <div className='pl-[28px] 2xl:pl-0 w-2/3 md:w-1/2 2xl:w-full flex flex-col 2xl:gap-desktop'>
            <h2 tabIndex={0}>{subTitle}</h2>
            <Slogan slogan={slogan} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderBlockContent
